module.exports = __webpack_public_path__ + "media/couriers/royal_mail-114f955d.png";